
<template>
<div>

  <v-dialog scrollable width="450"  persistent    v-model="tasks.task.actions.getIn.conditions.modal">
  <app-taskCond :conditions="tasks.task.actions.getIn.conditions" ></app-taskCond>
  </v-dialog>

  <v-dialog scrollable width="450"  persistent    v-model="tasks.task.actions.post.conditions.modal">
  <app-taskCond :conditions="tasks.task.actions.post.conditions" ></app-taskCond>
  </v-dialog>

  <v-dialog scrollable width="450"  persistent    v-model="tasks.task.actions.createTopic.conditions.modal">
  <app-taskCond :conditions="tasks.task.actions.createTopic.conditions" ></app-taskCond>
  </v-dialog>

  <v-dialog scrollable width="450"  persistent    v-model="tasks.task.actions.message.conditions.modal">
  <app-taskCond :conditions="tasks.task.actions.message.conditions" ></app-taskCond>
  </v-dialog>

  <v-dialog scrollable width="450"  persistent    v-model="tasks.task.actions.getOut.conditions.modal">
  <app-taskCond :conditions="tasks.task.actions.getOut.conditions" ></app-taskCond>
  </v-dialog>



<v-card>
  <v-toolbar dark  color="#4A76A8" flat  height="42">
  <v-icon large>mdi-worker</v-icon>   <v-toolbar-title  >     {{tasks.task.info.name}}   </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-icon @click="tasks.modals.actions = false">mdi-close</v-icon>
  </v-toolbar>

<v-card-text fluid style="height:60vh; overflow-x:hidden">

  <v-expansion-panel>

    <v-expansion-panel-content>
      <div  class="text-xs-center"  slot="header"><span style="font-weight:bold;color:#707070;font-size:1.3em;">Вступить в сообщество </span> <span  v-if="tasks.task.actions.getIn.activated" style="margin-left:10px;font-weight:bold;color:green;font-size:1.3em">(актив.) </span> </div>
      <v-card>
        <div style="padding:5px">
<v-btn color="#4A76A8" class="white--text" block @click="conditionAct('getIn')">   Изменить условия выполнения  </v-btn>
<v-checkbox color="#4A76A8" v-model="tasks.task.actions.getIn.activated" label="Активировать действие"> </v-checkbox>
        </div>
      </v-card>
    </v-expansion-panel-content>




    <v-expansion-panel-content>
      <div  class="text-xs-center"  slot="header"><span style="font-weight:bold;color:#707070;font-size:1.3em;">Предложить пост </span> <span  v-if="tasks.task.actions.post.activated" style="margin-left:10px;font-weight:bold;color:green;font-size:1.3em">(актив.) </span> </div>
      <v-card>

<div style="margin:10px">  <v-textarea v-model="tasks.task.actions.post.text" color="#4A76A8" label="Введите содержимое поста"></v-textarea> </div>

        <div style="padding:5px">
<v-btn  color="#4A76A8" class="white--text" block @click="conditionAct('post')">   Изменить условия выполнения  </v-btn>
<div ><v-checkbox   color="#4A76A8" v-model="tasks.task.actions.post.activated"   label="Активировать действие"> </v-checkbox></div>
        </div>
      </v-card>
    </v-expansion-panel-content>




    <v-expansion-panel-content>
      <div  class="text-xs-center"  slot="header"> <span style="font-weight:bold;color:#707070;font-size:1.3em;"> Создать обсуждение </span> <span  v-if="tasks.task.actions.createTopic.activated" style="margin-left:10px;font-weight:bold;color:green;font-size:1.3em">(актив.) </span> </div>
      <v-card>
<div style="margin:10px">        <v-text-field v-model="tasks.task.actions.createTopic.title" color="#4A76A8" label="Введите заголовок обсуждения" > </v-text-field> </div>
<div style="margin:10px">        <v-textarea v-model="tasks.task.actions.createTopic.text" color="#4A76A8" label="Введите содержание обсуждения"></v-textarea>  </div>
        <div style="padding:5px">
<v-btn  color="#4A76A8" class="white--text" block @click="conditionAct('createTopic')">   Изменить условия выполнения  </v-btn>
<v-checkbox color="#4A76A8" v-model="tasks.task.actions.createTopic.activated" label="Активировать действие"> </v-checkbox>
        </div>
      </v-card>
    </v-expansion-panel-content>






    <v-expansion-panel-content>
      <div  class="text-xs-center"  slot="header"><span style="font-weight:bold;color:#707070;font-size:1.3em;">Написать сообщение </span><span  v-if="tasks.task.actions.message.activated" style="margin-left:10px;font-weight:bold;color:green;font-size:1.3em">(актив.) </span> </div>
      <v-card>
<div style="margin:10px">        <v-textarea v-model="tasks.task.actions.message.text" color="#4A76A8" label="Введите ваше сообщение"></v-textarea>  </div>
        <div style="padding:5px">
<v-btn color="#4A76A8" class="white--text" block @click="conditionAct('message')">   Изменить условия выполнения  </v-btn>
<v-checkbox color="#4A76A8" v-model="tasks.task.actions.message.activated" label="Активировать действие"> </v-checkbox>
        </div>
      </v-card>
    </v-expansion-panel-content>







    <v-expansion-panel-content>
      <div  class="text-xs-center"  slot="header"><span style="font-weight:bold;color:#707070;font-size:1.3em;"> Покинуть сообщество </span> <span  v-if="tasks.task.actions.getOut.activated" style="margin-left:10px;font-weight:bold;color:green;font-size:1.3em">(актив.) </span> </div>
      <v-card>
        <div style="padding:5px">
<v-btn color="#4A76A8" class="white--text" block @click="conditionAct('getOut')">   Изменить условия выполнения  </v-btn>
<v-checkbox color="#4A76A8" v-model="tasks.task.actions.getOut.activated" label="Активировать действие"> </v-checkbox>
        </div>
      </v-card>
    </v-expansion-panel-content>



  </v-expansion-panel>





</v-card-text>

<v-card-actions>
<v-spacer></v-spacer>
<v-btn color="#4A76A8" flat small @click.native="tasks.modals.actions=false">Закрыть</v-btn>
<v-btn color="#4A76A8" small class="white--text" @click="changeActions()" >Сохранить </v-btn>
</v-card-actions>


</v-card>
</div>
</template>

<script>

import axios from 'axios'
export default {
props:['tasks' ],
  data () {
    return {


    }
  },
methods:{
  conditionAct(actName){

    if(actName == 'getIn'){
        this.tasks.task.actions.getIn.conditions.modal =  true
    }

    if(actName == 'post'){
        this.tasks.task.actions.post.conditions.modal =  true
    }

    if(actName == 'createTopic'){
   this.tasks.task.actions.createTopic.conditions.modal =  true
    }

    if(actName == 'message'){
   this.tasks.task.actions.message.conditions.modal =  true
    }

    if(actName == 'getOut'){
   this.tasks.task.actions.getOut.conditions.modal =  true
    }
  },



  changeActions(){


    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/change_actions.php', {
         method: 'POST',
         data: {
           actions: this.tasks.task.actions,
           taskId: this.tasks.task.info.task_id
         }
       })
       .then( response => {
          this.tasksData()
       })


  },
  tasksData: function(){

    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/task_for_export.php', {
         method: 'POST',
         data: {
           contentType: 'groups'
         }
       })
       .then( response => {
         this.tasks.tasksList = response.data
         this.tasks.modals.actions = false

       })

  },


},
beforeDestroy() {

}

}
</script>

<style   >

</style>
